export function ProductCardSkeleton() {
  return (
    <article className="group h-full flex flex-col rounded-2xl border border-glass-line/15 bg-gradient-to-b from-raised/70 via-surface/80 to-canvas/85 px-1.5 pt-0 pb-1.5 animate-pulse">
      <div className="relative aspect-[4/3] w-full rounded-xl bg-line/30" />
      <div className="min-h-0 flex-1" />
      <div className="px-1 text-left mt-2 space-y-3">
        <div className="product-title-plate flex min-h-14 items-center rounded-xl border border-glass-line/15 bg-surface/90 px-2 py-1.5 shadow-sm shadow-canvas/30 backdrop-blur-md">
          <div className="h-5 w-3/4 bg-line/30 rounded" />
        </div>
        <div className="flex min-h-[2.25rem] items-end justify-end gap-2 pt-2">
          <div className="h-6 w-24 bg-line/30 rounded" />
          <div className="h-4 w-16 bg-line/30 rounded" />
        </div>
      </div>
      <div className="mt-3 space-y-2">
        <div className="h-10 w-full bg-line/30 rounded-xl" />
        <div className="h-8 w-full bg-line/30 rounded-xl" />
      </div>
    </article>
  );
}

export function ProductCardSkeletonCompact() {
  return (
    <article className="group h-full flex flex-col rounded-2xl border border-glass-line/15 bg-gradient-to-b from-raised/70 via-surface/80 to-canvas/85 px-1.5 pt-0 pb-1.5 animate-pulse">
      <div className="relative aspect-[4/3] w-full rounded-xl bg-line/30" />
      <div className="min-h-0 flex-1" />
      <div className="px-1 text-left mt-2 space-y-2">
        <div className="product-title-plate flex min-h-14 items-center rounded-xl border border-glass-line/15 bg-surface/90 px-2 py-1.5 shadow-sm shadow-canvas/30 backdrop-blur-md">
          <div className="h-5 w-1/2 bg-line/30 rounded" />
        </div>
        <div className="flex min-h-[2.25rem] items-end justify-end gap-2 pt-2">
          <div className="h-6 w-20 bg-line/30 rounded" />
        </div>
      </div>
      <div className="mt-3">
        <div className="h-10 w-full bg-line/30 rounded-xl" />
      </div>
    </article>
  );
}

export function HeroProductCardSkeleton() {
  return (
    <div className="flex-1 glass-card p-4">
      <div className="flex h-full flex-col justify-center gap-2">
        <span className="inline-flex w-fit items-center gap-1 rounded-full border border-warning/40 bg-warning/10 px-2.5 py-0.5 text-xs font-semibold text-warning animate-pulse">⭐ Más Vendidos</span>
        <ProductCardSkeleton />
      </div>
    </div>
  );
}

export function AdminProductEditorSkeleton() {
  return (
    <div className="space-y-3 rounded-2xl border border-line bg-raised/40 p-3 sm:p-4 animate-pulse">
      <div className="relative mx-auto max-w-xs">
        <div className="aspect-square w-full rounded-xl bg-line/30" />
      </div>
      <div className="h-10 w-full bg-line/30 rounded-xl" />
      <div className="space-y-3 border-t border-line p-3">
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="h-10 w-full bg-line/30 rounded-xl" />
          <div className="h-10 w-full bg-line/30 rounded-xl" />
          <div className="h-10 w-full bg-line/30 rounded-xl" />
          <div className="h-10 w-full bg-line/30 rounded-xl" />
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="h-10 w-full bg-line/30 rounded-xl" />
          <div className="h-10 w-full bg-line/30 rounded-xl" />
        </div>
        <div className="h-10 w-full bg-line/30 rounded-xl" />
        <div className="h-20 w-full bg-line/30 rounded-xl" />
        <div className="flex items-center gap-2 border-t border-line pt-3">
          <div className="h-9 w-9 rounded-lg bg-line/30" />
          <div className="h-9 w-9 rounded-lg bg-line/30" />
          <div className="h-9 w-9 rounded-lg bg-line/30" />
          <div className="ml-auto h-9 w-20 rounded-lg bg-line/30" />
        </div>
      </div>
    </div>
  );
}

export function QuickServiceCardSkeleton() {
  return (
    <div className="flex-1 glass-card p-4">
      <div className="flex h-full flex-col gap-3 animate-pulse">
        <div className="space-y-2">
          <div className="h-6 w-2/3 bg-line/30 rounded" />
          <div className="h-4 w-full bg-line/30 rounded" />
        </div>
        <div className="grid grid-cols-1 gap-2.5">
          <div className="h-14 w-full bg-line/30 rounded-xl" />
          <div className="h-14 w-full bg-line/30 rounded-xl" />
          <div className="h-14 w-full bg-line/30 rounded-xl" />
          <div className="h-14 w-full bg-line/30 rounded-xl" />
        </div>
        <div className="h-5 w-1/3 bg-line/30 rounded-full" />
        <div className="h-10 w-full bg-line/30 rounded-full" />
      </div>
    </div>
  );
}

export function HeroSectionSkeleton() {
  return (
    <section className="home-snap-section relative px-5 sm:px-6 lg:px-10 min-h-[calc(100dvh-4rem)] py-12 sm:min-h-[calc(100dvh-4.5rem)] md:min-h-[calc(100dvh-5.5rem)] md:py-20 lg:min-h-screen animate-pulse">
      <div className="mx-auto w-full max-w-[1800px]">
        <div className="grid items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5 lg:block lg:text-left space-y-5">
            <div className="h-5 w-24 bg-line/30 rounded-full" />
            <div className="space-y-4">
              <div className="h-12 w-3/4 bg-line/30 rounded" />
              <div className="h-10 w-full bg-line/30 rounded" />
            </div>
            <div className="h-14 w-48 bg-line/30 rounded-full" />
          </div>
          <div className="flex w-full items-stretch gap-3 lg:col-span-7 lg:w-[94%] lg:justify-self-end">
            <HeroProductCardSkeleton />
            <div className="w-px shrink-0 self-stretch rounded-full bg-line/70" />
            <QuickServiceCardSkeleton />
          </div>
          <div className="flex flex-wrap items-center justify-center gap-2 pt-3 lg:col-span-12">
            <div className="h-6 w-24 bg-line/30 rounded-full" />
            <div className="h-6 w-24 bg-line/30 rounded-full" />
            <div className="h-6 w-24 bg-line/30 rounded-full" />
          </div>
        </div>
      </div>
    </section>
  );
}

export function TrustBadgeSkeleton() {
  return (
    <span className="trust-badge-item inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium backdrop-blur-md shadow-sm animate-pulse">
      <div className="h-3.5 w-3.5 bg-line/30 rounded" />
      <div className="h-4 w-20 bg-line/30 rounded" />
    </span>
  );
}